export enum FreightServiceType {
    NORMAL = 0,
    PLUS = 1
}